<div class="desktop-container">
    <div class="min-w-0">
        <span class="intro min-w-0">
            <div class="min-w-0">
                <h3 class="p-0 m-0">{{ title }}</h3>
                <app-assigned-item-meta class="text-xs mt-1" [meta]="meta"></app-assigned-item-meta>
            </div>
        </span>
    </div>
    <p-tag [styleClass]="badge.styleClass" [value]="badge.label"></p-tag>
    <app-flight-card-cta class="w-full" [flight]="issue" [type]="'issue'" [canBeArchived]="true" [asListRow]="true"></app-flight-card-cta>
</div>

<div class="mobile-container" (click)="$event.stopPropagation()">
  <app-combined-task-card-mobile
    [data]="issue"
    [type]="'issue'"
    [showEdit]="showEdit"
        [asListRow]="true"
  ></app-combined-task-card-mobile>
</div>
